import { lazy } from 'react';

import type { WidgetMapper } from 'ui/containers/ContentBuilder';

const linkpayment = lazy(
  () => import(/* webpackChunkName: "container-order-link-payment" */ './PayWithdrawals'),
);

const ordercta = lazy(
  () =>
    import(
      /* webpackChunkName: "container-order-success-cta-v2" */ '../BankSlip/widgets/OrderSuccessCta'
    ),
);

const orderinfo = lazy(
  () =>
    import(
      /* webpackChunkName: "container-order-success-info-v2" */ '../BankSlip/widgets/OrderSuccessInfo'
    ),
);

export const orderOtherMapper: WidgetMapper = {
  linkpayment,
  orderinfo,
  ordercta,
};
